import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
export function MessageInput({ onSend, disabled = false }) {
    const [value, setValue] = useState("");
    const textareaRef = useRef(null);
    function handleInput(e) {
        setValue(e.target.value);
        const el = e.target;
        el.style.height = "auto";
        el.style.height = `${Math.min(el.scrollHeight, 80)}px`;
    }
    function handleKeyDown(e) {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            submit();
        }
    }
    function submit() {
        const trimmed = value.trim();
        if (!trimmed || disabled)
            return;
        onSend(trimmed);
        setValue("");
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
        }
    }
    const hasText = value.trim().length > 0;
    return (_jsxs("div", { className: "px-[14px] pt-[10px] pb-5 border-t border-ink-100 bg-ink-050 flex items-end gap-2", children: [_jsx("textarea", { ref: textareaRef, rows: 1, value: value, onChange: handleInput, onKeyDown: handleKeyDown, placeholder: "Escribe un mensaje\u2026", disabled: disabled, className: "flex-1 resize-none bg-ink-050 border-[1.5px] border-ink-100 rounded-[12px] px-[14px] py-[11px] text-[15px] max-h-[88px] overflow-y-auto focus:border-brand-primary outline-none placeholder:text-ink-400 disabled:opacity-50 font-body" }), _jsx("button", { type: "button", onClick: submit, disabled: !hasText || disabled, "aria-label": "Enviar mensaje", className: `w-[44px] h-[44px] rounded-[12px] flex items-center justify-center transition-colors shrink-0 ${hasText && !disabled
                    ? "bg-brand-primary hover:bg-brand-primary/90 cursor-pointer"
                    : "bg-ink-100 cursor-not-allowed"}`, children: _jsx("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", children: _jsx("path", { d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z", fill: hasText && !disabled ? "white" : "#94a3b8" }) }) })] }));
}
//# sourceMappingURL=MessageInput.js.map